import SwiperSlider from './SwiperSlider';
import YoutubeVideoPlayer from '@/js/components/VideoPlayers/YoutubeVideoPlayer.js';

function createAllSliderCreativeIframeElements(event) {
  let block = event.target;

  while (!block.classList.contains('slider-creative') && block.parentNode) {
    block = block.parentNode;
  }

  if (!block) {
    return;
  }

  block.removeEventListener(
    'touchstart',
    createAllSliderCreativeIframeElements
  );
  block.removeEventListener('mouseover', createAllSliderCreativeIframeElements);

  const buttons = Array.from(
    block.querySelectorAll('.slider-creative__slide-video-button')
  );

  for (let button of buttons) {
    button.removeEventListener('focus', createAllSliderCreativeIframeElements);
    button.removeEventListener('click', createAllSliderCreativeIframeElements);
  }

  const playerElements = Array.from(
    block.querySelectorAll('.slider-creative__slide-player')
  );

  for (let playerElement of playerElements) {
    if (playerElement.dataset.videoIframe) {
      playerElement.innerHTML += playerElement.dataset.videoIframe;
      playerElement.removeAttribute('data-video-iframe');
    }
  }
}

export default class SliderCreative {
  playerList = {};

  slideMaxWidth = 580;
  slideMaxHeight = 390;
  slideInactiveScale = 0.35;
  spaceBetween = 30;
  mainBreakpoint = 768;
  speed = 300;
  currentTimeout = undefined;

  init() {
    const blocks = Array.from(document.querySelectorAll('.slider-creative'));

    YoutubeVideoPlayer.loadTheYoutubeIframeApi();

    for (let [blockIndex, block] of blocks.entries()) {
      this.playerList[blockIndex] = {};
      this.playerList[blockIndex].currentVideoPlayer = undefined;

      const slider = new SwiperSlider(block.querySelector('.swiper'), {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoHeight: true,
        roundLengths: true,
        watchSlidesProgress: true,
        speed: this.speed,
        spaceBetween: this.spaceBetween,
        breakpoints: {
          [this.mainBreakpoint]: {
            virtualTranslate: true,
            autoHeight: false,
          },
        },
        navigation: {
          nextEl: block.querySelector('.swiper-button-next'),
          prevEl: block.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: block.querySelector('.swiper-pagination'),
          ...SwiperSlider.paginationConfig,
        },
        on: {
          afterInit: (swiper) => {
            setTimeout(() => {
              this.loadAndPlaySlide(blockIndex, 0, swiper.slides[0], false);
            }, 1000);
          },
          slideChange: (swiper) => {
            this.stopVideo(blockIndex);

            this.loadAndPlaySlide(
              blockIndex,
              swiper.activeIndex,
              swiper.slides[swiper.activeIndex],
              false
            );

            if (
              window.matchMedia(`(min-width: ${this.mainBreakpoint}px)`).matches
            ) {
              const inactiveSlideWidth =
                this.slideMaxWidth * this.slideInactiveScale;
              const realInactiveSlideWidth =
                inactiveSlideWidth + this.spaceBetween;

              const translationValue =
                -1 * swiper.activeIndex * realInactiveSlideWidth;

              if (this.currentTimeout) {
                clearTimeout(this.currentTimeout);
              }

              this.currentTimeout = setTimeout(() => {
                swiper.slidesEl.style.transform = `translate3d(${translationValue}px, 0px, 0px) rotateZ(0deg)`;
              }, this.speed / 2);
            }
          },
          breakpoint: (swiper) => {
            this.stopVideo(blockIndex);

            swiper.update();
            swiper.slideTo(0, 0, false);
          },
        },
      });

      const videoButtons = Array.from(
        block.querySelectorAll('.slider-creative__slide-video-button')
      );

      for (let videoButton of videoButtons) {
        videoButton.addEventListener(
          'focus',
          createAllSliderCreativeIframeElements,
          false
        );
        videoButton.addEventListener(
          'click',
          createAllSliderCreativeIframeElements,
          false
        );
        videoButton.addEventListener('click', () => {
          if (this.playerList[blockIndex].currentVideoPlayer) {
            this.playVideo(blockIndex);
          } else {
            this.loadAndPlaySlide(
              blockIndex,
              slider.swiper.activeIndex,
              slider.swiper.slides[slider.swiper.activeIndex],
              true
            );
          }

          const slide =
            slider.swiper.slides[parseInt(videoButton.dataset.slideIndex)];

          if (slide) {
            slide.classList.add('video-played');
          }
        });
      }

      block.addEventListener(
        'mouseover',
        createAllSliderCreativeIframeElements,
        false
      );
      block.addEventListener(
        'touchstart',
        createAllSliderCreativeIframeElements,
        false
      );
    }
  }

  loadAndPlaySlide(blockIndex, slideIndex, activeSlide, autoplay = true) {
    if (
      this.playerList[blockIndex] &&
      this.playerList[blockIndex][slideIndex]
    ) {
      this.setPlayerByIndexAndPlay(blockIndex, slideIndex, true);
    } else {
      if (
        !activeSlide ||
        !activeSlide.classList.contains('slider-creative__swiper-slide--video')
      ) {
        return;
      }

      const youtubePlayerElement = activeSlide.querySelector('iframe');

      if (youtubePlayerElement) {
        this.playerList[blockIndex][slideIndex] = new YoutubeVideoPlayer(
          youtubePlayerElement,
          {},
          true
        );
      }

      this.setPlayerByIndexAndPlay(blockIndex, slideIndex, autoplay);
    }
  }

  setPlayerByIndexAndPlay(blockIndex, slideIndex, autoplay = true) {
    if (!this.playerList[blockIndex][slideIndex]) {
      return;
    }

    this.playerList[blockIndex].currentVideoPlayer =
      this.playerList[blockIndex][slideIndex];

    this.loadVideo(blockIndex, autoplay);
  }

  loadVideo(blockIndex, autoplay = true) {
    if (this.playerList[blockIndex].currentVideoPlayer) {
      this.playerList[blockIndex].currentVideoPlayer.load(autoplay);
    }
  }

  playVideo(blockIndex) {
    if (this.playerList[blockIndex].currentVideoPlayer) {
      this.playerList[blockIndex].currentVideoPlayer.play();
    }
  }

  pauseVideo(blockIndex) {
    if (this.playerList[blockIndex].currentVideoPlayer) {
      this.playerList[blockIndex].currentVideoPlayer.pause();
    }
  }

  stopVideo(blockIndex) {
    if (this.playerList[blockIndex].currentVideoPlayer) {
      this.playerList[blockIndex].currentVideoPlayer.stop();
    }
  }
}
